var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tags),function(tag,index){return _c('span',{key:index,staticClass:"mr-2"},[_c('span',{staticClass:"regular-16"},[_vm._v(_vm._s(tag)),(index < _vm.tags.length - 1)?_c('span',[_vm._v(",")]):_vm._e()])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }